import {initParallaxSection} from "../components/parallax-section";

export function initSamaraTravelLanding() {
    if (!$('#samara_travel_landing').length) return;
    initParallaxSection();
}
